import { getLifecycleConfirmation } from "../lib/propertyLifecycle";

function LifecycleConfirmModal({
  id,
  actionId,
  property,
  onConfirm,
  isBusy,
  confirmClassName = "action-btn action-btn--success",
  cancelClassName = "action-btn",
}) {
  const confirm = getLifecycleConfirmation(actionId, property);
  if (!confirm) return null;

  return (
    <div className="modal fade project-modal" id={id} tabIndex="-1" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h3 className="modal-title">{confirm.title}</h3>
            <div
              className="modal-btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="fa-solid fa-xmark fa-2x" aria-hidden="true" />
            </div>
          </div>
          <div className="modal-body">
            <p>{confirm.body}</p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className={cancelClassName}
              data-bs-dismiss="modal"
            >
              Скасувати
            </button>
            <button
              type="button"
              className={confirmClassName}
              data-bs-dismiss="modal"
              onClick={onConfirm}
              disabled={isBusy}
            >
              {confirm.confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LifecycleConfirmModal;
